<template>
  <v-card class="my-4">
    <v-card-title> Marketplace </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          v-for="item in visibleItems"
          :key="item.id"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card outlined>
            <v-card-title>
              <v-chip v-if="!item.priced_at" small> A consultar... </v-chip>
              <v-spacer></v-spacer>
              <v-menu>
                <template #activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="item.priced_at && item.price > 0"
                    @click="handleClickGenerateReport(item.id)"
                  >
                    <v-list-item-content>
                      <v-list-item-title> Gerar Relatório </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="handleClickDestroy(item.id)">
                    <v-list-item-content>
                      <v-list-item-title> Excluir </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-img :src="item.thumb_src" height="100" contain></v-img>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-wrap font-weight-medium">
                  {{ item.marketplace_product_name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <div v-if="item.priced_at">
              <v-simple-table dense class="mb-3 mt-2">
                <tbody>
                  <tr>
                    <th width="100">Loja</th>
                    <td>{{ item.store_name || "---" }}</td>
                  </tr>
                  <tr>
                    <th>Stock</th>
                    <td>{{ item.in_stock ? "Em stock" : "Out of stock" }}</td>
                  </tr>
                  <tr>
                    <th>Valor</th>
                    <td>{{ item.price ? euro(item.price) : "---" }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-card-actions>
                <v-btn
                  v-if="item.store_link"
                  :href="item.store_link"
                  target="_blank"
                  small
                  block
                  color="purple"
                  dark
                  outlined
                >
                  Ver anúncio
                </v-btn>
                <v-btn
                  v-else
                  :href="`https://marketplace.portalhcm.com/price-reports/${item.marketplace_report_id}`"
                  target="_blank"
                  small
                  block
                  color="purple"
                  dark
                  outlined
                >
                  Ver orçamentação
                </v-btn>
              </v-card-actions>
            </div>
            <div v-else class="pa-4">
              <v-simple-table dense class="mb-3 mt-2">
                <tbody>
                  <tr>
                    <th width="100">Loja</th>
                    <td>
                      <v-skeleton-loader type="text"></v-skeleton-loader>
                    </td>
                  </tr>
                  <tr>
                    <th>Stock</th>
                    <td>
                      <v-skeleton-loader type="text"></v-skeleton-loader>
                    </td>
                  </tr>
                  <tr>
                    <th>Valor</th>
                    <td>
                      <v-skeleton-loader type="text"></v-skeleton-loader>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-card-actions>
                <v-btn
                  small
                  block
                  color="purple"
                  outlined
                  dark
                  :href="`https://marketplace.portalhcm.com/price-reports/${item.marketplace_report_id}`"
                  target="_blank"
                >
                  Acompanhar <v-icon right>mdi-open-in-new</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-card
            link
            flat
            style="height: 100%; min-height: 300px"
            class="d-flex justify-center align-center"
            color="purple lighten-4"
            :disabled="linking"
            @click="handleClickNew()"
          >
            <div class="text-center">
              <v-icon size="70"> mdi-plus </v-icon>
              <br />
              <span class="caption"> Adicionar </span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  storeSession,
  destroySession,
  generateReport,
} from "@/services/marketplace/marketplace";
import Formatter from "@/tools/money";

export default {
  mixins: [],

  components: {},

  props: {
    items: Array,
    productId: Number,
  },

  data() {
    return {
      linking: false,
      euro: Formatter.euro,
      pooling: null,
    };
  },

  methods: {
    async handleClickNew() {
      this.linking = true;

      try {
        const { data } = await storeSession({
          lead_id: this.lead.id,
          product_id: this.productId,
        });

        console.log(data);

        window.location.href = data.session_url;
      } finally {
        this.linking = false;
      }
    },
    async handleClickDestroy(id) {
      if (!confirm("Tem certeza?")) {
        return;
      }

      await destroySession(id);

      this.$emit("destroyed", id);
    },
    async handleClickGenerateReport(id) {
      await generateReport(id);
      window.location.reload();
    },

    startPooling() {
      if (this.pooling) {
        return;
      }

      this.pooling = setInterval(() => {
        const leadNumber = this.$route.params.lead_number;
        const productId = this.$route.params.product_id;

        this.$store.dispatch("product/loadProduct", {
          productId,
          leadNumber,
        });
      }, 3000);
    },

    stopPooling() {
      if (!this.pooling) {
        return;
      }

      clearInterval(this.pooling);
      this.pooling = null;
    },
  },

  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },

    visibleItems() {
      return this.items.filter((item) => !!item.marketplace_report_id);
    },
  },

  created() {
    this.startPooling();
  },

  beforeDestroy() {
    this.stopPooling();
  },
};
</script>
